module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg26-08a8d2ce124c86ba9dfa8d6a9805bf29.jpg";